import API, { handleRequest } from "@/api/lib/api";

export const getCalender = (restaurant_id, query = "") =>
  handleRequest(() =>
    API.get(`restaurant/staff-time-sheets/${restaurant_id}?month=${query}`)
  );

export const getRoadmap = (id) =>
  handleRequest(() =>
    API.get(`restaurant/staff-time-sheets/road-map/${id}`)
  );

export const getPresentDataBydate = (
  restaurant_id,
  date,
  page = 1,
  perPage = 10
) =>
  handleRequest(() =>
    API.get(
      `restaurant/staff-calender-details/${restaurant_id}?date=${date}&page=${page}&per_page=${perPage}`
    )
  );
